var _g, _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedAllParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_430_13223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.6079,
    r: 27.5,
    fill: "#0B74BB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.8014,
    height: 30.8014,
    transform: "translate(20.0703 19.6045)",
    fill: "#0B74BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1885 24.4172C31.5305 24.4172 29.3758 26.572 29.3758 29.23C29.3758 31.8879 31.5305 34.0427 34.1885 34.0427C36.8465 34.0427 39.0012 31.8879 39.0012 29.23C39.0012 26.572 36.8465 24.4172 34.1885 24.4172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0549 36.6095C26.3969 36.6095 24.2422 38.7642 24.2422 41.4222V42.9472C24.2422 43.9139 24.9428 44.7381 25.8968 44.8939C31.3882 45.7905 36.9887 45.7905 42.4801 44.8939C43.4342 44.7381 44.1348 43.9139 44.1348 42.9472V41.4222C44.1348 38.7642 41.98 36.6095 39.322 36.6095H38.8846C38.6478 36.6095 38.4125 36.6469 38.1874 36.7204L37.0766 37.0831C35.2 37.6959 33.177 37.6959 31.3003 37.0831L30.1895 36.7204C29.9644 36.6469 29.7292 36.6095 29.4924 36.6095H29.0549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0973 27.6257C45.6289 27.6257 46.0599 28.0567 46.0599 28.5883V30.8342H48.3058C48.8374 30.8342 49.2683 31.2651 49.2683 31.7967C49.2683 32.3283 48.8374 32.7593 48.3058 32.7593H46.0599V35.0052C46.0599 35.5368 45.6289 35.9678 45.0973 35.9678C44.5657 35.9678 44.1348 35.5368 44.1348 35.0052V32.7593H41.8888C41.3572 32.7593 40.9263 32.3283 40.9263 31.7967C40.9263 31.2651 41.3572 30.8342 41.8888 30.8342H44.1348V28.5883C44.1348 28.0567 44.5657 27.6257 45.0973 27.6257Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_430_13223",
    x: 0.437323,
    y: 0.545233,
    width: 70.1254,
    height: 70.1254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_430_13223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_430_13223",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedAllParticipants);
export default __webpack_public_path__ + "static/media/selected_all_participants.69c29937a12891b2d1f1ca0e3058a1aa.svg";
export { ForwardRef as ReactComponent };